import { IZipCodeInformationBaseViewModel } from 'viewModels';
import api from '../services/api/axios';

const getZipCodeWithGeoLocation = (zipCode: string) =>
  new Promise<IZipCodeInformationBaseViewModel>((resolve, reject) => {
    api
      .post(`informationbasezipcode`, { cep: zipCode })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const InformationBaseZipCodeController = { getZipCodeWithGeoLocation };

export default InformationBaseZipCodeController;
